module.exports = __webpack_public_path__ + "static/img/2-bg.12437fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/2-bg.png
// module id = prRq
// module chunks = 0